export default __webpack_public_path__ + "static/media/intercom-toolbox.f0a4161c.svg";